<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="来源">
        <a-input :value="typeLabel" disabled />
      </a-form-model-item>
      <a-form-model-item label="用户名称">
        <a-input :value="form.userName || '—'" disabled />
      </a-form-model-item>
      <a-form-model-item label="姓名">
        <a-input :value="form.name || '—'" disabled />
      </a-form-model-item>
      <a-form-model-item label="身份证号码">
        <a-input :value="form.identification || '—'" disabled />
      </a-form-model-item>
      <a-form-model-item label="身份证正面">
        <img
          v-if="form.identityFront"
          v-viewer
          :src="form.identityFront"
          preview="图片"
          class="auth-thumb"
        />
        <span v-else class="text-muted">—</span>
      </a-form-model-item>
      <a-form-model-item label="身份证反面">
        <img
          v-if="form.identityInverse"
          v-viewer
          :src="form.identityInverse"
          preview="图片"
          class="auth-thumb"
        />
        <span v-else class="text-muted">—</span>
      </a-form-model-item>
      <a-form-model-item label="平台审核状态" prop="status">
        <a-select v-model="form.status" placeholder="请选择审核状态" @change="onAuditStatusChange">
          <a-select-option :value="0">待审核</a-select-option>
          <a-select-option :value="1">已通过</a-select-option>
          <a-select-option :value="-1">已驳回</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item v-if="Number(form.status) !== 1" label="审核原因" prop="rejectReason">
        <a-input v-model="form.rejectReason" placeholder="驳回时请填写原因" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-input v-model="form.remark" placeholder="请输入备注" type="textarea" :rows="3" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getAuthentication, addAuthentication, updateAuthentication } from '@/api/authentication/authentication'

export default {
  name: 'CreateForm',
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        type: null,
        userId: null,
        userName: null,
        name: null,
        identification: null,
        identityFront: null,
        identityInverse: null,
        face: null,
        status: 0,
        rejectReason: null,
        createTime: null,
        remark: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        status: [
          { required: true, message: '平台审核状态不能为空', trigger: 'change' }
        ],
        rejectReason: [
          {
            validator: (rule, value, callback) => {
              if (this.form.status === -1 && !(value && String(value).trim())) {
                callback(new Error('审核驳回时请填写审核原因'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    typeLabel () {
      if (this.form.type === 0) return '用户端'
      if (this.form.type === 1) return '师傅端'
      return '—'
    }
  },
  methods: {
    /** 选择已通过时不需要审核原因，清空并避免提交带上旧驳回说明 */
    onAuditStatusChange (val) {
      if (Number(val) === 1) {
        this.form.rejectReason = null
        this.$nextTick(() => {
          if (this.$refs.form) {
            this.$refs.form.clearValidate(['rejectReason'])
          }
        })
      }
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        type: null,
        userId: null,
        userName: null,
        name: null,
        identification: null,
        identityFront: null,
        identityInverse: null,
        face: null,
        status: 0,
        rejectReason: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getAuthentication({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '审核'
      })
    },
    /** 提交按钮（审核仅提交状态、原因、备注） */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            const reviewPayload = {
              id: this.form.id,
              status: this.form.status,
              rejectReason: Number(this.form.status) === 1 ? null : this.form.rejectReason,
              remark: this.form.remark
            }
            updateAuthentication(reviewPayload).then(response => {
              this.$message.success(
                '保存成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addAuthentication(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
.auth-thumb {
  width: 120px;
  height: 80px;
  object-fit: cover;
  cursor: pointer;
  border-radius: 4px;
  border: 1px solid #f0f0f0;
}
.text-muted {
  color: rgba(0, 0, 0, 0.25);
}
</style>
